import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: '/master',
            component(resolve) {
                require.ensure(['../views/master.vue'], () => {
                    resolve(require('../views/master.vue'));
                });
            },
            children: [
                {
                    path: '/',
                    name: '/home',
                    component(resolve) {
                        require.ensure(['../views/home.vue'], () => {
                            resolve(require('../views/home.vue'));
                        });
                    },
                },
                {
                    path: '/product',
                    name: '/product',
                    component(resolve) {
                        require.ensure(['../views/product.vue'], () => {
                            resolve(require('../views/product.vue'));
                        });
                    },
                },
                {
                    path: '/order',
                    name: '/order',
                    component(resolve) {
                        require.ensure(['../views/order.vue'], () => {
                            resolve(require('../views/order.vue'));
                        });
                    },
                },
                {
                    path: '/home',
                    name: '/home',
                    component(resolve) {
                        require.ensure(['../views/home.vue'], () => {
                            resolve(require('../views/home.vue'));
                        });
                    },
                },
                {
                    path: '/about_us',
                    name: '/about_us',
                    component(resolve) {
                        require.ensure(['../views/about_us.vue'], () => {
                            resolve(require('../views/about_us.vue'));
                        });
                    },
                },
                {
                    path: '/recharge_detail',
                    name: '/recharge_detail',
                    component(resolve) {
                        require.ensure(['../views/recharge_detail.vue'], () => {
                            resolve(require('../views/recharge_detail.vue'));
                        });
                    },
                },
                {
                    path: '/result',
                    name: '/result',
                    component(resolve) {
                        require.ensure(['../views/result.vue'], () => {
                            resolve(require('../views/result.vue'));
                        });
                    },
                }
            ]
        },

    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js